export const TRANSACTION_TYPE_SALE = 'sale';
export const TRANSACTION_TYPE_AUTH = 'auth';
export const TRANSACTION_TYPE_ACH = 'processAch';
export const TRANSACTION_TYPE_VOID = 'void';
export const TRANSACTION_TYPE_REFUND = 'refund';
export const TRANSACTION_TYPE_CHARGE = 'charge';
export const TRANSACTION_TYPE_CAPTURE = 'capture';
export const TRANSACTION_TYPE_VERIFY = 'verify';

export const TRANSACTION_CODE_AUTH = 'AUTH';
export const TRANSACTION_CODE_SALE = 'SALE';
export const TRANSACTION_CODE_VOID = 'VOID';
export const TRANSACTION_CODE_REFUND = 'RTRN';
export const TRANSACTION_CODE_CHARGE = 'SRTRN';
export const TRANSACTION_CODE_ACH = 'ACH';
export const TRANSACTION_CODE_TKTO = 'TKTO';

export const TRANSACTION_ACH_TYPE_CHECKING = 'Checking';
export const TRANSACTION_ACH_TYPE_SAVINGS = 'Savings';
export const TRANSACTION_ACH_SEC_CODE_WEB = 'WEB';
export const TRANSACTION_ACH_SEC_CODE_TEL = 'TEL';
export const TRANSACTION_ACH_SEC_CODE_PPD = 'PPD';
export const TRANSACTION_ACH_SEC_CODE_CCD = 'CCD';

export const TRANSACTION_PAYMENT_TYPE_CREDIT = 'CREDIT_CARD';

export const TRANSACTION_BALANCE_INQUIRY = 'info';
export const DIGITAL_WALLET_TYPE_MAP = {
  apple_pay: 'Apple pay',
  google_pay: 'Google pay'
};

export const THREE_DS_STATUS_LABELS_MAP = {
  authenticated: 'Authenticated',
  attempt_acknowledged: 'Attempt acknowledged',
  failed: 'Failed'
};
